import { store } from '@/store';
import { setState } from '@/store/commonSlice'


const isDev = () => {
  return process.env.NODE_ENV === 'development'
}

//显示loading
const showLoading = (delay = 0) => {
  store.dispatch(setState({ type: 'SET_COMMON_STATE', key: 'isLoading', value: true }))

}

//隐藏loading
const hideLoading = () => {
  store.dispatch(setState({ type: 'SET_COMMON_STATE', key: 'isLoading', value: false }))

}

export {
  isDev,
  showLoading,
  hideLoading
}